import { Typography } from './Typography';
import { Button } from './Button';
import { Image } from './Image';

export function BannerCard({ image, title, buttonText, onButtonClick }) {
  return (
    <div
      style={{
        position: 'relative',
        borderRadius: 24,
        overflow: 'hidden',
        margin: '1em 0',
        width: '100%',
        minHeight: 180,
      }}
    >
      <Image src={image} alt="" style={{ width: '100%', height: 180, objectFit: 'cover' }} />
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(180deg, #0000 60%, #0006 100%)',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          padding: '1.5em',
        }}
      >
        <Typography type="h2" text={title} size="large" color="#fff" />
        <Button variant="secondary" onClick={onButtonClick} style={{ marginTop: 12 }}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
